import { takeLatest, put, call } from 'redux-saga/effects'
import qs from 'qs'
import moment from 'moment'
import { Types } from '../ducks/management'
import oikosApi from '../../services/oikos'
import { notifyError, notifySuccess } from '../../utils/notify'
import { sendEmailToNotify, printStandardEmail } from '../../utils/fc'

/** PHP insertData converte null em '' — omitir null/undefined/'' evita erro em colunas INT/DATE. */
const sanitizeOikosInsertData = (data) => {
  const out = {}
  Object.keys(data || {}).forEach((key) => {
    const value = data[key]
    if (value === null || value === undefined || value === '') return
    out[key] = value
  })
  return out
}

function* getLegalSolicitations(action) {
  try {
    const contrato_id = action.payload
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'solicitacoes_juridicas',
      data: contrato_id ? { contrato_id } : undefined,
    })}`)

    yield put({
      type: Types.GET_LEGAL_SOLICITATIONS_SUCCEEDED,
      payload: res.data || [],
    })
  } catch (err) {
    console.log(err)
    notifyError('Não foi possível carregar as solicitações jurídicas.')
    yield put({ type: Types.GET_LEGAL_SOLICITATIONS_FAILED, payload: err.toString() })
  }
}

function* getLegalSolicitationResponses(action) {
  try {
    const solicitacao_id = action.payload
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'solicitacoes_juridicas_respostas',
      data: { solicitacao_id },
    })}`)

    yield put({
      type: Types.GET_LEGAL_SOLICITATION_RESPONSES_SUCCEEDED,
      payload: res.data || [],
    })
  } catch (err) {
    console.log(err)
    notifyError('Não foi possível carregar as respostas.')
    yield put({ type: Types.GET_LEGAL_SOLICITATION_RESPONSES_FAILED, payload: err.toString() })
  }
}

function* postLegalSolicitationResponse(action) {
  try {
    const { anexoFile, ...data } = action.payload
    const res = yield oikosApi.post('/', {
      action: 'insert',
      table: 'solicitacoes_juridicas_respostas',
      data,
    })

    if (res.data?.error || (res.data?.status === 'error')) {
      throw new Error(res.data.error || 'Erro reportado pelo PHP')
    }

    const insertedId = res.data[0]?.id || res.data[0]?.solicitacoes_juridicas_respostas_id

    if (anexoFile && insertedId) {
      try {
        const formData = new FormData()
        formData.append('file', new Blob([anexoFile], { type: anexoFile.type }), anexoFile.name)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'solicitacoes_juridicas_respostas')
        formData.append('arquivo_tabId', insertedId)
        formData.append('arquivo_desc', anexoFile.name)
        formData.append('arquivo_privacidade', '1')

        const uploadRes = yield oikosApi.post('/', formData)
        const resStr = typeof uploadRes.data === 'string' ? uploadRes.data : JSON.stringify(uploadRes.data)
        const match = resStr.match(/\[\{"arquivo_id".*?\}\]/)

        if (match) {
          const parsedArr = JSON.parse(match[0])
          if (parsedArr && parsedArr[0] && parsedArr[0].arquivo_caminho) {
            yield oikosApi.post('/', {
              action: 'update',
              table: 'solicitacoes_juridicas_respostas',
              data: {
                solicitacoes_juridicas_respostas_id: insertedId,
                anexo: parsedArr[0].arquivo_caminho
              }
            })
          }
        }
      } catch (err) {
        console.log('Falha silenciosa ao processar anexo (upload/regex):', err)
      }
    }

    // Se houve mudança de status na resposta, atualizar a solicitação pai
    if (data.status_alterado_para) {
      yield put({
        type: Types.UPDATE_STATUS_REQUESTED,
        payload: {
          table: 'solicitacoes_juridicas',
          idField: 'solicitacoes_juridicas_id',
          idValue: data.solicitacao_id,
          status: data.status_alterado_para,
        }
      })
    }

    notifySuccess('Resposta enviada com sucesso!')
    yield put({ type: Types.POST_LEGAL_SOLICITATION_RESPONSE_SUCCEEDED })

    yield put({ type: Types.GET_LEGAL_SOLICITATION_RESPONSES_REQUESTED, payload: data.solicitacao_id })
  } catch (err) {
    console.log(err)
    notifyError('Falha ao enviar resposta.')
    yield put({ type: Types.POST_LEGAL_SOLICITATION_RESPONSE_FAILED, payload: err.toString() })
  }
}

function* postLegalSolicitation(action) {
  try {
    const { anexoFile, solicitanteExibicao, ...data } = action.payload
    const res = yield oikosApi.post('/', {
      action: 'insert',
      table: 'solicitacoes_juridicas',
      data,
    })

    console.log('DEBUG RESPOSTA API (POST SOLICITATION):', res.data)

    if (res.data?.error || (res.data?.status === 'error')) {
      throw new Error(res.data.error || 'Erro reportado pelo PHP')
    }

    const insertedId = res.data[0]?.id || res.data[0]?.solicitacoes_juridicas_id

    if (anexoFile && insertedId) {
      try {
        const formData = new FormData()
        formData.append('file', new Blob([anexoFile], { type: anexoFile.type }), anexoFile.name)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'solicitacoes_juridicas')
        formData.append('arquivo_tabId', insertedId)
        formData.append('arquivo_desc', anexoFile.name)
        formData.append('arquivo_privacidade', '1')

        const uploadRes = yield oikosApi.post('/', formData)

        const resStr = typeof uploadRes.data === 'string' ? uploadRes.data : JSON.stringify(uploadRes.data)
        const match = resStr.match(/\[\{"arquivo_id".*?\}\]/)

        if (match) {
          const parsedArr = JSON.parse(match[0])
          if (parsedArr && parsedArr[0] && parsedArr[0].arquivo_caminho) {
            yield oikosApi.post('/', {
              action: 'update',
              table: 'solicitacoes_juridicas',
              data: {
                solicitacoes_juridicas_id: insertedId,
                anexo: parsedArr[0].arquivo_caminho
              }
            })
          }
        }
      } catch (err) {
        console.log('Falha silenciosa ao processar anexo (upload/regex):', err)
      }
    }

    if (insertedId) {
      try {
        const subject = `Novo Chamado Jurídico: ${data.tipo_assunto || ''}`
        const message = printStandardEmail(`
          <div style="margin-bottom: 20px;">
            <p>Olá,</p>
            <p>Um novo <b>Chamado Jurídico</b> foi aberto no Oikos. Confira os detalhes abaixo:</p>
          </div>
          <strong>Solicitante: </strong><span>${solicitanteExibicao || data.solicitante || ''}</span><br />
          <strong>Assunto: </strong><span>${data.tipo_assunto || ''}</span><br />
          <strong>Prioridade: </strong><span>${data.prioridade || ''}</span><br />
          <strong>Prazo de Atendimento: </strong><span>${data.prazo_atendimento ? moment(data.prazo_atendimento).format('DD/MM/YYYY') : ''}</span><br />
          <br />
          <strong>Teor:</strong><br />
          ${data.teor || ''}
        `)

        yield call(sendEmailToNotify, 'gerencia.juridico@ecossis.com.br', subject, message, 'juridico@ecossis.com.br')
      } catch (err) {
        console.log('Erro ao disparar e-mail de chamado jurídico:', err)
      }
    }

    notifySuccess('Solicitação jurídica enviada com sucesso!')
    yield put({ type: Types.POST_LEGAL_SOLICITATION_SUCCEEDED })

    // Recarregar a lista caso necessário
    if (data.contrato_id) {
      yield put({ type: Types.GET_LEGAL_SOLICITATIONS_REQUESTED, payload: data.contrato_id })
    } else {
      yield put({ type: Types.GET_LEGAL_SOLICITATIONS_REQUESTED })
    }
  } catch (err) {
    console.log(err)
    notifyError('Falha ao enviar solicitação jurídica.')
    yield put({ type: Types.POST_LEGAL_SOLICITATION_FAILED, payload: err.toString() })
  }
}

function* getOfficialLettersCreated(action) {
  try {
    const contrato_id = action.payload
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'oficios_criados',
      data: contrato_id ? { contrato_id } : undefined,
    })}`)

    yield put({
      type: Types.GET_OFFICIAL_LETTERS_CREATED_SUCCEEDED,
      payload: res.data || [],
    })
  } catch (err) {
    console.log(err)
    notifyError('Não foi possível carregar os ofícios criados.')
    yield put({ type: Types.GET_OFFICIAL_LETTERS_CREATED_FAILED, payload: err.toString() })
  }
}

function* reloadOfficialLetters(table, contrato_id) {
  if (table === 'oficios_criados') {
    yield put({ type: Types.GET_OFFICIAL_LETTERS_CREATED_REQUESTED, payload: contrato_id })
  } else if (table === 'oficios_recebidos') {
    yield put({ type: Types.GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED, payload: contrato_id })
  }
}

/** Busca solicitacoes_juridicas_id em oficios_recebidos pelo id. */
function* fetchReceivedLegalDemandId(receivedId) {
  if (!receivedId) return null
  try {
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'oficios_recebidos',
      data: { oficios_recebidos_id: receivedId },
    })}`)
    const row = Array.isArray(res.data) ? res.data[0] : null
    return row?.solicitacoes_juridicas_id || null
  } catch (err) {
    console.log('Falha ao consultar demanda do ofício recebido:', err)
    return null
  }
}

/**
 * @param {number} oficioId
 * @param {object} letterData
 * @param {object} demanda_juridica
 * @param {'created'|'received'} source
 */
function* createLegalDemandFromOficio(oficioId, letterData, demanda_juridica, source = 'created') {
  if (letterData.solicitacoes_juridicas_id) {
    throw new Error('Este ofício já possui demanda jurídica vinculada.')
  }

  const isReceived = source === 'received'
  if (!isReceived) {
    const linkedReceivedId = letterData.oficio_origem_recebido_id || letterData.oficios_recebidos_id
    const linkedDemandId = yield call(fetchReceivedLegalDemandId, linkedReceivedId)
    if (linkedDemandId) {
      throw new Error(`O ofício recebido vinculado já possui demanda jurídica (#${linkedDemandId}).`)
    }
  }

  const dj = demanda_juridica || {}
  const assuntoFallback = isReceived
    ? (letterData.assunto || letterData.assunto_teor || 'Ofício recebido')
    : (letterData.assunto || 'Ofício')
  const teorFallback = isReceived
    ? (letterData.teor || letterData.assunto_teor || '')
    : (letterData.teor || '')
  const solicitanteFallback = isReceived
    ? (letterData.responsavel_assinatura || '')
    : (letterData.responsavel_assinatura || '')
  const fatoPrefix = isReceived ? 'Ofício recebido' : 'Ofício'

  const solRes = yield oikosApi.post('/', {
    action: 'insert',
    table: 'solicitacoes_juridicas',
    data: {
      solicitante: dj.solicitante || solicitanteFallback,
      tipo_assunto: dj.tipo_assunto || (typeof assuntoFallback === 'string' && !assuntoFallback.includes('<') ? assuntoFallback : 'Ofício'),
      prioridade: dj.prioridade || 'Sugestão',
      teor: dj.teor || teorFallback,
      prazo_atendimento: dj.prazo_atendimento || letterData.prazo_resposta || letterData.data_oficio || moment().format('YYYY-MM-DD'),
      fato_gerador: dj.fato_gerador || `${fatoPrefix} ${letterData.numero_oficio || oficioId}`,
      status: 'Aguardando atendimento',
      contrato_id: letterData.contrato_id || undefined,
    },
  })
  const solId = solRes.data?.[0]?.solicitacoes_juridicas_id || solRes.data?.[0]?.id
  if (!solId) {
    throw new Error('Não foi possível criar a solicitação jurídica.')
  }

  if (dj.anexoFile) {
    try {
      const formData = new FormData()
      formData.append('file', new Blob([dj.anexoFile], { type: dj.anexoFile.type }), dj.anexoFile.name)
      formData.append('table', 'arquivo')
      formData.append('action', 'upload_file')
      formData.append('arquivo_tabRef', 'solicitacoes_juridicas')
      formData.append('arquivo_tabId', solId)
      formData.append('arquivo_desc', dj.anexoFile.name)
      formData.append('arquivo_privacidade', '1')

      const uploadRes = yield oikosApi.post('/', formData)
      const resStr = typeof uploadRes.data === 'string' ? uploadRes.data : JSON.stringify(uploadRes.data)
      const match = resStr.match(/\[\{"arquivo_id".*?\}\]/)

      if (match) {
        const parsedArr = JSON.parse(match[0])
        if (parsedArr && parsedArr[0] && parsedArr[0].arquivo_caminho) {
          yield oikosApi.post('/', {
            action: 'update',
            table: 'solicitacoes_juridicas',
            data: {
              solicitacoes_juridicas_id: solId,
              anexo: parsedArr[0].arquivo_caminho,
            },
          })
        }
      }
    } catch (err) {
      console.log('Falha silenciosa ao processar anexo da demanda jurídica (upload/regex):', err)
    }
  }

  if (isReceived) {
    yield oikosApi.post('/', {
      action: 'update',
      table: 'oficios_recebidos',
      data: {
        oficios_recebidos_id: oficioId,
        solicitacoes_juridicas_id: solId,
        gerar_demanda_juridica: 1,
      },
    })
  } else {
    yield oikosApi.post('/', {
      action: 'update',
      table: 'oficios_criados',
      data: {
        oficios_criados_id: oficioId,
        solicitacoes_juridicas_id: solId,
        gerar_demanda_juridica: 1,
      },
    })
  }

  const emailAssunto = isReceived
    ? (letterData.assunto || 'Ofício recebido')
    : (letterData.assunto || '')
  const emailContraParte = isReceived
    ? (letterData.remetente || '')
    : (letterData.destinatario || '')
  const contraParteLabel = isReceived ? 'Remetente' : 'Destinatário'

  const subject = `Novo Chamado Jurídico (via Ofício): ${emailAssunto}`
  const message = printStandardEmail(`
    <p>Demanda jurídica gerada automaticamente a partir do ofício <b>${letterData.numero_oficio || oficioId}</b>.</p>
    <strong>Assunto: </strong><span>${emailAssunto}</span><br />
    <strong>${contraParteLabel}: </strong><span>${emailContraParte}</span><br />
    <br /><strong>Teor:</strong><br />${dj.teor || teorFallback}
  `)
  yield call(sendEmailToNotify, 'gerencia.juridico@ecossis.com.br', subject, message, 'juridico@ecossis.com.br')

  return solId
}

/** Ao vincular criado↔recebido, espelha solicitacoes_juridicas_id se só um dos lados tiver. */
function* mirrorLegalDemandOnLink(createdId, receivedId) {
  if (!createdId || !receivedId) return
  try {
    const createdRes = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'oficios_criados',
      data: { oficios_criados_id: createdId },
    })}`)
    const receivedRes = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'oficios_recebidos',
      data: { oficios_recebidos_id: receivedId },
    })}`)
    const created = Array.isArray(createdRes.data) ? createdRes.data[0] : null
    const received = Array.isArray(receivedRes.data) ? receivedRes.data[0] : null
    if (!created || !received) return

    const cDemand = created.solicitacoes_juridicas_id
    const rDemand = received.solicitacoes_juridicas_id

    if (cDemand && rDemand && Number(cDemand) !== Number(rDemand)) {
      console.log(`Demandas divergentes ao vincular: criado #${cDemand} vs recebido #${rDemand}`)
      return
    }

    if (rDemand && !cDemand) {
      yield oikosApi.post('/', {
        action: 'update',
        table: 'oficios_criados',
        data: {
          oficios_criados_id: createdId,
          solicitacoes_juridicas_id: rDemand,
          gerar_demanda_juridica: 1,
        },
      })
    } else if (cDemand && !rDemand) {
      yield oikosApi.post('/', {
        action: 'update',
        table: 'oficios_recebidos',
        data: {
          oficios_recebidos_id: receivedId,
          solicitacoes_juridicas_id: cDemand,
          gerar_demanda_juridica: 1,
        },
      })
    }
  } catch (err) {
    console.log('Falha ao espelhar demanda jurídica no vínculo:', err)
  }
}

function* postOfficialLetterCreated(action) {
  try {
    const { anexoFile, gerar_demanda_juridica, demanda_juridica, ...data } = action.payload

    const linkedReceivedId = data.oficio_origem_recebido_id || data.oficios_recebidos_id
    if (gerar_demanda_juridica && linkedReceivedId) {
      const linkedDemandId = yield call(fetchReceivedLegalDemandId, linkedReceivedId)
      if (linkedDemandId) {
        notifyError(`O ofício recebido vinculado já possui demanda jurídica (#${linkedDemandId}).`)
        yield put({
          type: Types.POST_OFFICIAL_LETTER_CREATED_FAILED,
          payload: `Demanda #${linkedDemandId} já vinculada ao ofício recebido.`,
        })
        return
      }
    }

    const insertData = sanitizeOikosInsertData({
      ...data,
      gerar_demanda_juridica: gerar_demanda_juridica ? 1 : 0,
    })
    const res = yield oikosApi.post('/', {
      action: 'insert',
      table: 'oficios_criados',
      data: insertData,
    })

    if (res.data?.error || (res.data?.status === 'error')) {
      throw new Error(res.data.error || 'Erro reportado pelo PHP')
    }

    const insertedId = res.data[0]?.id || res.data[0]?.oficios_criados_id

    if (anexoFile && insertedId) {
      try {
        const formData = new FormData()
        formData.append('file', new Blob([anexoFile], { type: anexoFile.type }), anexoFile.name)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'oficios_criados')
        formData.append('arquivo_tabId', insertedId)
        formData.append('arquivo_desc', anexoFile.name)
        formData.append('arquivo_privacidade', '1')

        const uploadRes = yield oikosApi.post('/', formData)

        const resStr = typeof uploadRes.data === 'string' ? uploadRes.data : JSON.stringify(uploadRes.data)
        const match = resStr.match(/\[\{"arquivo_id".*?\}\]/)

        if (match) {
          const parsedArr = JSON.parse(match[0])
          if (parsedArr && parsedArr[0] && parsedArr[0].arquivo_caminho) {
            yield oikosApi.post('/', {
              action: 'update',
              table: 'oficios_criados',
              data: {
                oficios_criados_id: insertedId,
                anexo: parsedArr[0].arquivo_caminho
              }
            })
          }
        }
      } catch (err) {
        console.log('Falha silenciosa ao processar anexo (upload/regex):', err)
      }
    }

    if (data.oficio_origem_recebido_id && insertedId) {
      try {
        yield oikosApi.post('/', {
          action: 'update',
          table: 'oficios_criados',
          data: {
            oficios_criados_id: insertedId,
            oficios_recebidos_id: data.oficio_origem_recebido_id,
            oficio_origem_recebido_id: data.oficio_origem_recebido_id,
          },
        })
        yield oikosApi.post('/', {
          action: 'update',
          table: 'oficios_recebidos',
          data: {
            oficios_recebidos_id: data.oficio_origem_recebido_id,
            oficios_criados_resposta_id: insertedId,
            status: 'Finalizado',
          },
        })
        yield call(mirrorLegalDemandOnLink, insertedId, data.oficio_origem_recebido_id)
      } catch (err) {
        console.log('Falha ao vincular resposta ao ofício recebido:', err)
      }
    } else if (data.oficios_recebidos_id && insertedId) {
      yield call(mirrorLegalDemandOnLink, insertedId, data.oficios_recebidos_id)
    }

    if (gerar_demanda_juridica && insertedId) {
      try {
        yield call(createLegalDemandFromOficio, insertedId, data, demanda_juridica, 'created')
      } catch (err) {
        console.log('Falha ao gerar demanda jurídica:', err)
      }
    }

    notifySuccess('Ofício gerado e salvo com sucesso!')
    yield put({ type: Types.POST_OFFICIAL_LETTER_CREATED_SUCCEEDED })

    if (data.contrato_id) {
      yield put({ type: Types.GET_OFFICIAL_LETTERS_CREATED_REQUESTED, payload: data.contrato_id })
      if (data.oficio_origem_recebido_id || data.oficios_recebidos_id) {
        yield put({ type: Types.GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED, payload: data.contrato_id })
      }
    } else {
      yield put({ type: Types.GET_OFFICIAL_LETTERS_CREATED_REQUESTED })
      if (data.oficio_origem_recebido_id || data.oficios_recebidos_id) {
        yield put({ type: Types.GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED })
      }
    }
  } catch (err) {
    console.log(err)
    notifyError('Falha ao salvar ofício.')
    yield put({ type: Types.POST_OFFICIAL_LETTER_CREATED_FAILED, payload: err.toString() })
  }
}

function* getOfficialLettersReceived(action) {
  try {
    const contrato_id = action.payload
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'oficios_recebidos',
      data: contrato_id ? { contrato_id } : undefined,
    })}`)

    yield put({
      type: Types.GET_OFFICIAL_LETTERS_RECEIVED_SUCCEEDED,
      payload: res.data || [],
    })
  } catch (err) {
    console.log(err)
    notifyError('Não foi possível carregar os ofícios recebidos.')
    yield put({ type: Types.GET_OFFICIAL_LETTERS_RECEIVED_FAILED, payload: err.toString() })
  }
}

function* postOfficialLetterReceived(action) {
  try {
    const { anexoFile, gerar_demanda_juridica, demanda_juridica, ...data } = action.payload
    const insertData = sanitizeOikosInsertData({
      ...data,
      gerar_demanda_juridica: gerar_demanda_juridica ? 1 : 0,
    })
    const res = yield oikosApi.post('/', {
      action: 'insert',
      table: 'oficios_recebidos',
      data: insertData,
    })

    if (res.data?.error || (res.data?.status === 'error')) {
      throw new Error(res.data.error || 'Erro reportado pelo PHP')
    }

    const insertedId = res.data[0]?.id || res.data[0]?.oficios_recebidos_id

    let uploadedFilePath = null;

    if (anexoFile && insertedId) {
      try {
        const formData = new FormData()
        formData.append('file', new Blob([anexoFile], { type: anexoFile.type }), anexoFile.name)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'oficios_recebidos')
        formData.append('arquivo_tabId', insertedId)
        formData.append('arquivo_desc', anexoFile.name)
        formData.append('arquivo_privacidade', '1')

        const uploadRes = yield oikosApi.post('/', formData)

        const resStr = typeof uploadRes.data === 'string' ? uploadRes.data : JSON.stringify(uploadRes.data)
        const match = resStr.match(/\[\{"arquivo_id".*?\}\]/)

        if (match) {
          const parsedArr = JSON.parse(match[0])
          if (parsedArr && parsedArr[0] && parsedArr[0].arquivo_caminho) {
            uploadedFilePath = parsedArr[0].arquivo_caminho;
            yield oikosApi.post('/', {
              action: 'update',
              table: 'oficios_recebidos',
              data: {
                oficios_recebidos_id: insertedId,
                anexo: parsedArr[0].arquivo_caminho
              }
            })
          }
        }
      } catch (err) {
        console.log('Falha silenciosa ao processar anexo (upload/regex):', err)
      }
    }

    if (data.encaminhar_para_email) {
      try {
        const baseUrl = process.env.REACT_APP_URL || 'https://oikoslab.ecoss.is/';
        const anexoLink = uploadedFilePath
          ? `<br /><br /><strong>Anexo:</strong> <a href="${baseUrl}oikos/${uploadedFilePath}" target="_blank">Clique aqui para visualizar o PDF</a>`
          : '';

        const subject = `Novo Ofício Recebido: ${data.remetente || ''}`
        const message = printStandardEmail(`
          <div style="margin-bottom: 20px;">
            <p>Olá,</p>
            <p>Um novo <b>Ofício</b> foi recebido pela Ecossis. Confira os detalhes abaixo:</p>
          </div>
          <strong>Remetente: </strong><span>${data.remetente || ''}</span><br />
          <strong>Data do Ofício: </strong><span>${data.data_oficio ? moment(data.data_oficio).format('DD/MM/YYYY') : ''}</span><br />
          <strong>Setores Responsáveis: </strong><span>${data.setor_responsavel || ''}</span><br />
          <br />
          <strong>Teor/Assunto:</strong><br />
          ${data.assunto_teor || ''}
          ${anexoLink}
        `)

        yield call(sendEmailToNotify, data.encaminhar_para_email, subject, message, data.com_copia_para || '')
      } catch (err) {
        console.log('Erro ao disparar e-mail de ofício recebido:', err)
      }
    }

    if (gerar_demanda_juridica && insertedId) {
      try {
        yield call(createLegalDemandFromOficio, insertedId, {
          ...data,
          assunto: data.assunto_teor,
          teor: data.assunto_teor,
        }, demanda_juridica, 'received')
      } catch (err) {
        console.log('Falha ao gerar demanda jurídica do ofício recebido:', err)
      }
    }

    notifySuccess('Ofício recebido salvo com sucesso!')
    yield put({ type: Types.POST_OFFICIAL_LETTER_RECEIVED_SUCCEEDED })

    if (data.contrato_id) {
      yield put({ type: Types.GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED, payload: data.contrato_id })
      if (gerar_demanda_juridica) {
        yield put({ type: Types.GET_LEGAL_SOLICITATIONS_REQUESTED, payload: data.contrato_id })
      }
    } else {
      yield put({ type: Types.GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED })
      if (gerar_demanda_juridica) {
        yield put({ type: Types.GET_LEGAL_SOLICITATIONS_REQUESTED })
      }
    }
  } catch (err) {
    console.log(err)
    notifyError('Falha ao salvar ofício recebido.')
    yield put({ type: Types.POST_OFFICIAL_LETTER_RECEIVED_FAILED, payload: err.toString() })
  }
}

function* generateLegalDemandForOficio(action) {
  try {
    const { row, demanda_juridica, contrato_id, source = 'created' } = action.payload
    const isReceived = source === 'received'
    const oficioId = isReceived
      ? (row.oficios_recebidos_id || row.id)
      : (row.oficios_criados_id || row.id)
    if (!oficioId) throw new Error('Ofício não identificado.')
    if (row.solicitacoes_juridicas_id) {
      throw new Error('Este ofício já possui demanda jurídica vinculada.')
    }

    if (!isReceived) {
      const linkedReceivedId = row.oficio_origem_recebido_id || row.oficios_recebidos_id
      const linkedDemandId = yield call(fetchReceivedLegalDemandId, linkedReceivedId)
      if (linkedDemandId) {
        throw new Error(`O ofício recebido vinculado já possui demanda jurídica (#${linkedDemandId}).`)
      }
    } else if (row.oficios_criados_resposta_id) {
      try {
        const createdRes = yield oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'oficios_criados',
          data: { oficios_criados_id: row.oficios_criados_resposta_id },
        })}`)
        const created = Array.isArray(createdRes.data) ? createdRes.data[0] : null
        if (created?.solicitacoes_juridicas_id) {
          throw new Error(`O ofício criado vinculado já possui demanda jurídica (#${created.solicitacoes_juridicas_id}).`)
        }
      } catch (err) {
        if (String(err.message || err).includes('já possui demanda')) throw err
      }
    }

    yield call(
      createLegalDemandFromOficio,
      oficioId,
      isReceived
        ? { ...row, assunto: row.assunto || row.assunto_teor, teor: row.teor || row.assunto_teor }
        : row,
      demanda_juridica,
      isReceived ? 'received' : 'created',
    )

    // Espelha no outro lado se já houver vínculo
    if (!isReceived && (row.oficio_origem_recebido_id || row.oficios_recebidos_id)) {
      yield call(
        mirrorLegalDemandOnLink,
        oficioId,
        row.oficio_origem_recebido_id || row.oficios_recebidos_id,
      )
    } else if (isReceived && row.oficios_criados_resposta_id) {
      yield call(mirrorLegalDemandOnLink, row.oficios_criados_resposta_id, oficioId)
    }

    notifySuccess('Demanda jurídica gerada com sucesso!')
    yield put({ type: Types.GENERATE_LEGAL_DEMAND_FOR_OFICIO_SUCCEEDED })

    yield call(reloadOfficialLetters, isReceived ? 'oficios_recebidos' : 'oficios_criados', contrato_id)
    if (!isReceived && (row.oficio_origem_recebido_id || row.oficios_recebidos_id)) {
      yield call(reloadOfficialLetters, 'oficios_recebidos', contrato_id)
    } else if (isReceived && row.oficios_criados_resposta_id) {
      yield call(reloadOfficialLetters, 'oficios_criados', contrato_id)
    }
    if (contrato_id) {
      yield put({ type: Types.GET_LEGAL_SOLICITATIONS_REQUESTED, payload: contrato_id })
    } else {
      yield put({ type: Types.GET_LEGAL_SOLICITATIONS_REQUESTED })
    }
  } catch (err) {
    console.log(err)
    notifyError(err.message || 'Falha ao gerar demanda jurídica.')
    yield put({ type: Types.GENERATE_LEGAL_DEMAND_FOR_OFICIO_FAILED, payload: err.toString() })
  }
}

function* updateOfficialLetter(action) {
  try {
    const { table, idField, idValue, data, contrato_id, silent } = action.payload
    yield oikosApi.post('/', {
      action: 'update',
      table,
      data: {
        [idField]: idValue,
        ...data,
      },
    })

    if (table === 'oficios_criados' && data.oficios_recebidos_id) {
      yield call(mirrorLegalDemandOnLink, idValue, data.oficios_recebidos_id)
    }

    if (!silent) {
      notifySuccess('Ofício atualizado com sucesso.')
    }
    yield put({ type: Types.UPDATE_OFFICIAL_LETTER_SUCCEEDED })
    yield call(reloadOfficialLetters, table, contrato_id)
    if (table === 'oficios_criados' && data.oficios_recebidos_id) {
      yield call(reloadOfficialLetters, 'oficios_recebidos', contrato_id)
    }
  } catch (err) {
    console.log(err)
    notifyError('Falha ao atualizar ofício.')
    yield put({ type: Types.UPDATE_OFFICIAL_LETTER_FAILED, payload: err.toString() })
  }
}

function* updateStatus(action) {
  try {
    // payload deve conter: { table, idField, idValue, status, contrato_id }
    const { table, idField, idValue, status, contrato_id } = action.payload
    const res = yield oikosApi.post('/', {
      action: 'update',
      table,
      data: {
        [idField]: idValue,
        status,
      },
    })

    notifySuccess('Status alterado com sucesso.')
    yield put({ type: Types.UPDATE_STATUS_SUCCEEDED })

    // Recarregar a lista da tabela específica
    yield call(reloadOfficialLetters, table, contrato_id)
    if (table === 'solicitacoes_juridicas') {
      yield put({ type: Types.GET_LEGAL_SOLICITATIONS_REQUESTED, payload: contrato_id })
    }
  } catch (err) {
    console.log(err)
    notifyError('Falha ao alterar o status.')
    yield put({ type: Types.UPDATE_STATUS_FAILED, payload: err.toString() })
  }
}

function* getPortais(action) {
  try {
    const projeto_id = action.payload
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'portais',
      data: projeto_id ? { projeto_id } : undefined,
    })}`)

    yield put({
      type: Types.GET_PORTAIS_SUCCEEDED,
      payload: res.data || [],
    })
  } catch (err) {
    console.log(err)
    notifyError('Não foi possível carregar os portais.')
    yield put({ type: Types.GET_PORTAIS_FAILED, payload: err.toString() })
  }
}

function* postPortal(action) {
  try {
    const data = action.payload
    const res = yield oikosApi.post('/', data)

    if (res.data?.error || (res.data?.status === 'error')) {
      throw new Error(res.data.error || 'Erro reportado pelo PHP')
    }

    notifySuccess('Portal salvo com sucesso!')
    yield put({ type: Types.POST_PORTAL_SUCCEEDED })

    yield put({ type: Types.GET_PORTAIS_REQUESTED, payload: data.data.projeto_id })
  } catch (err) {
    console.log(err)
    notifyError('Falha ao salvar portal.')
    yield put({ type: Types.POST_PORTAL_FAILED, payload: err.toString() })
  }
}

export const managementSagas = [
  takeLatest(Types.GET_LEGAL_SOLICITATIONS_REQUESTED, getLegalSolicitations),
  takeLatest(Types.POST_LEGAL_SOLICITATION_REQUESTED, postLegalSolicitation),
  takeLatest(Types.GET_LEGAL_SOLICITATION_RESPONSES_REQUESTED, getLegalSolicitationResponses),
  takeLatest(Types.POST_LEGAL_SOLICITATION_RESPONSE_REQUESTED, postLegalSolicitationResponse),
  takeLatest(Types.GET_OFFICIAL_LETTERS_CREATED_REQUESTED, getOfficialLettersCreated),
  takeLatest(Types.POST_OFFICIAL_LETTER_CREATED_REQUESTED, postOfficialLetterCreated),
  takeLatest(Types.GET_OFFICIAL_LETTERS_RECEIVED_REQUESTED, getOfficialLettersReceived),
  takeLatest(Types.POST_OFFICIAL_LETTER_RECEIVED_REQUESTED, postOfficialLetterReceived),
  takeLatest(Types.UPDATE_STATUS_REQUESTED, updateStatus),
  takeLatest(Types.UPDATE_OFFICIAL_LETTER_REQUESTED, updateOfficialLetter),
  takeLatest(Types.GENERATE_LEGAL_DEMAND_FOR_OFICIO_REQUESTED, generateLegalDemandForOficio),
  takeLatest(Types.GET_PORTAIS_REQUESTED, getPortais),
  takeLatest(Types.POST_PORTAL_REQUESTED, postPortal),
]